import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/app-shell';
import { RequireAuth } from '@/features/auth/components/require-auth';
import { RequireActiveSubscription } from '@/features/subscription/require-active-subscription';
import { VoiceNoteMessages } from '@/features/voice-notes/components/voice-note-messages';
import { useMeQuery } from '@/lib/graphql/hooks.gen';

export const Route = createFileRoute('/_app')({
  component: AppLayout,
});

function AppLayout() {
  return (
    <RequireAuth>
      <AppShellOutlet />
    </RequireAuth>
  );
}

// Rendu uniquement dans la branche authentifiée de RequireAuth : les hooks
// (chemin courant, `me`) ne tournent donc jamais sur l'écran anonyme.
function AppShellOutlet() {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const { data } = useMeQuery();

  return (
    <RequireActiveSubscription>
      <AppShell currentPath={pathname} user={data?.me}>
        <Outlet />
        {/* FR-18 : partout dans l'application, le message d'un vocal prêt
            ou en échec. */}
        <VoiceNoteMessages />
      </AppShell>
    </RequireActiveSubscription>
  );
}
